import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  button: {
    '&:disabled': {
      backgroundColor: `${theme.palette.secondary.dark} !important`,
    },
  },
}));
